import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AuthUser, AdminUser } from "@/types/api";

interface UserState {
  user: AuthUser | null;
  admin: AdminUser | null;
  setUser: (user: AuthUser) => void;
  setAdmin: (admin: AdminUser) => void;
  clearUser: () => void;
  clearAdmin: () => void;
  clearAll: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      admin: null,
      setUser: (user) => set({ user }),
      setAdmin: (admin) => set({ admin }),
      clearUser: () => set({ user: null }),
      clearAdmin: () => set({ admin: null }),
      clearAll: () => set({ user: null, admin: null }),
    }),
    {
      name: "bomnal-user",
      partialize: (state) => ({
        user: state.user,
        admin: state.admin,
      }),
    },
  ),
);
